import { render } from "./KapibaraLoveStory.vue?vue&type=template&id=8c01ad96"
import script from "./KapibaraLoveStory.vue?vue&type=script&lang=js"
export * from "./KapibaraLoveStory.vue?vue&type=script&lang=js"

import "./KapibaraLoveStory.vue?vue&type=style&index=0&id=8c01ad96&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__